import { eyebrowClass, textStyleClass } from '@/utils/text-style';

import type { FunctionComponent } from 'react';
import type { TypeListingHeaderProps } from './types';

/**
 * Eyebrow + h1 sobre los filtros del listado. `listingHeaderEnabled`
 */
export const ListingHeader: FunctionComponent<TypeListingHeaderProps> = ({
  className = '',
  eyebrow,
  title,
  area,
  titleEstilo,
}) => {
  // El eyebrow del listado no tiene per-block override — usa la fuente
  // global `eyebrowEstilo` de ThemeConfiguration (= todos los eyebrows del
  // tenant se ven igual). `eyebrowClass(null)` ya cae al global.
  const eyebrowCls = eyebrowClass(null);
  const titleClass = textStyleClass(titleEstilo);

  return (
    // Patrón "kicker over headline" igual que ContentImage/FaqBlock/Prefooter:
    // el wrap se ciñe al ancho del título (`w-fit` aquí porque el padre
    // de ListingHeader no es flex container, así que `self-start` no
    // bastaba), y el eyebrow flota pegado a la derecha de ese borde
    // (`items-end`). El h1 queda al ancho natural del título.
    <div className={`flex w-fit flex-col items-end ${className}`}>
      {eyebrow && (
        <span
          className={`font-accent text-primary-500 ${eyebrowCls ?? 'text-base leading-tight md:text-3xl'}`}
        >
          {eyebrow}
        </span>
      )}
      <h1
        className={
          titleClass ?? 'text-text-primary text-4xl leading-tight font-bold'
        }
        id="list-flats-name"
      >
        {title}
        {area && <mark className="flow">{area}</mark>}
      </h1>
    </div>
  );
};

ListingHeader.displayName = 'ListingHeader';
